import { render, staticRenderFns } from "./PushList.vue?vue&type=template&id=12f81aca&scoped=true"
import script from "./PushList.vue?vue&type=script&lang=js"
export * from "./PushList.vue?vue&type=script&lang=js"
import style0 from "./PushList.vue?vue&type=style&index=0&id=12f81aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f81aca",
  null
  
)

export default component.exports